<template>
  <div class="flex-grow-1 d-flex flex-column overflow-hidden">
    <div ref="headBar" class="mb-3 pt-3 pl-3 pr-3 pb-2 bg-white">
      <div class="mb-2 clearfix" style="border-bottom:1px #ccc dotted;">
        <div class="float-left">
          <slot name="title"></slot>
          <div v-if="!$slots.title"><i class="fa fa-arrow-circle-o-right fa-fw"></i>{{ title }}</div>
        </div>
        <div class="float-right mb-2">
          <el-radio-group v-model="viewModel" size="mini">
            <el-radio-button label="grid" type1="success" title="网格模式" class="icon" :disabled="lockMode == 'card'"><i class="el-icon-s-grid"></i></el-radio-button>
            <el-radio-button label="card" type1="success" title="卡片模式" class="icon" :disabled="lockMode == 'grid'"><i class="el-icon-mobile-phone"></i></el-radio-button>
          </el-radio-group>
        </div>
      </div>
      <div class="d-md-flex flex-wrap align-items-center justify-content-end j-pin" ref="searchBar">
        <slot name="searchBar" :viewModel="viewModel"></slot>
      </div>
    </div>
    <div v-show="viewModel === 'card'" class="flex-grow-1 list-card">
      <slot name="card"></slot>
    </div>
    <div v-show="viewModel === 'grid'" class="flex-grow-1 bg-white overflow-hidden list-table" :class="{'is-tree': forTree}">
      <slot name="toolhead"></slot>
      <slot name="grid"></slot>
    </div>
  </div>
</template>

<script>
import tools from 'jyutils/tools';
export default {
  name: 'TemplateList',
  mixins: [tools],
  props: {
    title: String,
    forTree: Boolean, // grid区域放tree?
    lockMode: String, // 锁定模式[grid, card]
  },
  data() {
    return {
      viewModel: 'grid',
      barH: 0
    }
  },
  watch: {
    viewModel(val) {
      // table 重新layout
      if (val == 'grid') {
        this.$nextTick(() => {
          // let grid = this.$slots.grid ? this.$slots.grid[0] : null;
          // if (grid && grid.child && grid.child.$options && grid.child.$options._componentTag == 'el-table') {
          //   grid.child.doLayout();
          // }
        });
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.lockMode && (this.lockMode === 'card' || this.lockMode === 'grid')) {
        this.viewModel = this.lockMode;
      } else {
        this.viewModel = this.isSm ? 'card' : 'grid';
      }
      let obj = this.$refs.headBar;
      let oStyle = obj.currentStyle ? obj.currentStyle : window.getComputedStyle(obj, null);
      this.barH = parseFloat(oStyle.height);
    });
  },
  methods: {

  }
}
</script>
<style scoped>
.j-pin.pined{padding:.2rem; background-color:#f1f1f1;}
</style>
<style lang="less" scoped>
.list-card {
  overflow-x:hidden;
  overflow-y:auto;
}
.list-table {
  /deep/ .el-table--border, /deep/ .el-table--group {
    border-color:#fff;
  }
  &.is-tree {
    overflow-y:auto;
  }
}
</style>
